function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.564 2.077a4.487 4.487 0 100 8.974 4.487 4.487 0 000-8.974zM1 6.564a5.564 5.564 0 119.86 3.535l3.982 3.982a.538.538 0 11-.761.761l-3.982-3.981A5.564 5.564 0 011 6.564z",
  fill: "#2D2D2D"
});
function SvgLupa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Lupa.svg";
export { SvgLupa as ReactComponent };